'use strict';

var raf$1 = require('../../../../_virtual/raf.js_commonjs-exports.js');

raf$1.__exports.__esModule = true;
raf$1.__exports.default = raf;
function raf(callback) {
  if (window.requestAnimationFrame) {
    return window.requestAnimationFrame(callback);
  }

  var nativeRaf = window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;

  return nativeRaf ? nativeRaf(callback) : window.setTimeout(callback, 1e3 / 60);
}
